<div>
    <div *ngIf="!list || !list.length">
        {{ placeholder | translate }}
    </div>

    <div *ngIf="list && list.length && expanded">
        {{ getCompleteList() }}
        <a (click)="expanded = false">[-]</a>
    </div>

    <div *ngIf="list && list.length && !expanded">
        {{ getTruncatedList() }}
        <a *ngIf="getRemaining()" (click)="expanded = true">[+{{ getRemaining() }}]</a>
    </div>
</div>
